export default __webpack_public_path__ + "static/media/varo-bank-home-page.f7837ce1.svg";